export default "__VITE_ASSET__CNlPloH0__"